module.exports = __webpack_public_path__ + "media/bg.cd118c27.mp4";